import Footer from './Footer'
import useMultiSelect from './useMultiSelect'
import { styles } from './styles'

export default {
  Footer,
  useMultiSelect,
  styles,
}
